import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * Check if all spatialData has spatialIndex, which indecates tiled dataSource
 * @param {Object} spatialData Object of spatialDataSources
 * @returns {Boolean}
 */
var isSpatialDataTiled = function isSpatialDataTiled(spatialData) {
  var spatialDSTiled = [];

  for (var _i = 0, _Object$entries = Object.entries(spatialData); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        datasource = _Object$entries$_i[1];

    if (Object.hasOwn(datasource, 'spatialIndex')) {
      spatialDSTiled.push(true);
    } else {
      spatialDSTiled.push(false);
    }
  }

  return spatialDSTiled.every(function (tiled) {
    return tiled;
  });
};

export default {
  isSpatialDataTiled: isSpatialDataTiled
};